import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
const milestones = [{
  day: 'Noche 1',
  result: 'El llanto al acostarlo disminuye un 50%',
  progress: 33
}, {
  day: 'Noche 4',
  result: 'Los despertares por "hambre falsa" desaparecen',
  progress: 66
}, {
  day: 'Día 7',
  result: 'Tu bebé liga sus ciclos de sueño — duermes 6 horas seguidas',
  progress: 100
}];
export function ProofSection() {
  return <section className="w-full bg-[#faf7f2] py-16 md:py-24" data-id="element-161">
      <div className="max-w-4xl mx-auto px-4" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-163">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-164">
            <TrendingUpIcon className="w-8 h-8 text-[#22c55e]" data-id="element-165" />
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] text-center" data-id="element-166">
              Lo Que Cambia en <span className="text-[#d4a853]" data-id="element-167">7 Días</span>
            </h2>
          </div>

          <p className="font-['DM_Sans'] text-[#64748b] text-lg text-center mb-12 max-w-2xl mx-auto" data-id="element-168">
            En la primera noche, notarás que el llanto al acostarlo disminuye un
            50%. Para la cuarta noche, los despertares por "hambre falsa"
            desaparecen. Al séptimo día, tu bebé habrá aprendido a ligar sus
            ciclos de sueño, permitiéndote dormir 6 horas seguidas por primera
            vez en meses.
          </p>

          {/* Timeline */}
          <div className="relative" data-id="element-169">
            {/* Progress line */}
            <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-1 bg-[#ede5d8] transform md:-translate-x-1/2" data-id="element-170" />

            <div className="space-y-8" data-id="element-171">
              {milestones.map((milestone, index) => <motion.div key={index} className="relative flex items-center gap-6 md:gap-0" initial={{
              opacity: 0,
              x: index % 2 === 0 ? -30 : 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} data-id="element-172">
                  {/* Mobile layout */}
                  <div className="md:hidden flex items-start gap-4 w-full" data-id="element-173">
                    <div className="relative z-10 w-16 h-16 bg-[#d4a853] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-174">
                      <span className="font-['Playfair_Display'] text-sm font-bold text-[#0f172a] text-center leading-tight" data-id="element-175">
                        {milestone.day}
                      </span>
                    </div>
                    <div className="bg-white p-5 rounded-xl shadow-sm border border-[#ede5d8] flex-1" data-id="element-176">
                      <p className="font-['DM_Sans'] font-semibold text-[#0f172a] text-lg" data-id="element-177">
                        {milestone.result}
                      </p>
                      <div className="mt-3 h-2 bg-[#ede5d8] rounded-full overflow-hidden" data-id="element-178">
                        <motion.div className="h-full bg-gradient-to-r from-[#d4a853] to-[#22c55e] rounded-full" initial={{
                      width: 0
                    }} whileInView={{
                      width: `${milestone.progress}%`
                    }} viewport={{
                      once: true
                    }} transition={{
                      duration: 1,
                      delay: 0.5 + index * 0.2
                    }} data-id="element-179" />
                      </div>
                    </div>
                  </div>

                  {/* Desktop layout */}
                  <div className="hidden md:flex items-center w-full" data-id="element-180">
                    <div className={`w-5/12 ${index % 2 === 0 ? 'pr-8 text-right' : 'order-3 pl-8 text-left'}`} data-id="element-181">
                      <div className="bg-white p-6 rounded-xl shadow-sm border border-[#ede5d8] inline-block" data-id="element-182">
                        <p className="font-['DM_Sans'] font-semibold text-[#0f172a] text-lg mb-2" data-id="element-183">
                          {milestone.result}
                        </p>
                        <div className="h-2 bg-[#ede5d8] rounded-full overflow-hidden w-48" data-id="element-184">
                          <motion.div className="h-full bg-gradient-to-r from-[#d4a853] to-[#22c55e] rounded-full" initial={{
                        width: 0
                      }} whileInView={{
                        width: `${milestone.progress}%`
                      }} viewport={{
                        once: true
                      }} transition={{
                        duration: 1,
                        delay: 0.5 + index * 0.2
                      }} data-id="element-185" />
                        </div>
                      </div>
                    </div>

                    <div className="w-2/12 flex justify-center order-2" data-id="element-186">
                      <div className="relative z-10 w-20 h-20 bg-[#d4a853] rounded-full flex items-center justify-center shadow-lg" data-id="element-187">
                        <span className="font-['Playfair_Display'] text-sm font-bold text-[#0f172a] text-center leading-tight" data-id="element-188">
                          {milestone.day}
                        </span>
                      </div>
                    </div>

                    <div className={`w-5/12 ${index % 2 === 0 ? 'order-3' : ''}`} data-id="element-189" />
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}